import { toNumber } from 'lodash'

import { AvailabilityIF } from '@driftt/app-config/dist/utils/driftTypes'

export const getEndUserOnline = (onlineEndUsers, convoEndUser) =>
  !!onlineEndUsers?.has(toNumber(convoEndUser?.id))

export const getAgentOnline = (agentId, users) =>
  users.find((a) => a.id === Number(agentId))?.availability ===
  AvailabilityIF.AVAILABLE

export const getConversationMessageLink = (
  convoId: number,
  messageId: string | null
) =>
  `${window.DRIFT_CONFIG.APP_URL}/conversations/${convoId}${
    messageId ? `/${messageId}` : ''
  }`
